module.exports = __webpack_public_path__ + "static/media/gs.10673568.svg";